import React from 'react';

function WebBookingsSkeleton({ count = 3 }) {
    return (
        <div className="web-bookings-skeleton">
            {Array.from({ length: count }).map((_, index) => (
                <div key={`web-bookings-skeleton-${index}`} className="web-bookings-skeleton__card" />
            ))}
        </div>
    );
}

export default WebBookingsSkeleton;
